import React, { useCallback, useRef, useState } from 'react'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import FarmRolesForm from '@galo-monitor/web-containers/forms/company/FarmRolesForm'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

const FarmRolesModal = (props) => {
  const {
    id,
    open,
    handleClose,
    role,
    onSuccess
  } = props

  const [loading, setLoading] = useState(false)

  const t = useT()
  const { createDialog } = useDialog()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () => {
      formRef.current.submit()
    },
    []
  )

  const handleSuccess = useCallback(
    () => {
      handleClose()
      onSuccess()
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    err => {
      setLoading(false)
      createDialog({
        id: 'error-farm-roles',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'male',
            action: toLower(t(isEmpty(role) ? 'register' : 'update')),
            this: toLower(t('role', { howMany: 1 }))
          })  }.`,
          message: t(err.response.data.message || 'unexpected error occurred')
        }
      })
    },
    [createDialog, role, t]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ `${ t('register of {this}', { this: t('role', { howMany: 2 }) }) } Farm` }
      FooterComponent={ () => (
        <>
          <Button
            id="save"
            onClick={ handleConfirm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <FarmRolesForm
        ref={ formRef }
        role={ role }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
      />
    </Modal>
  )
}

FarmRolesModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  role: PropTypes.object
}

FarmRolesModal.defaultProps = {
  role: {}
}

export default FarmRolesModal
